import { applyMiddleware, createStore } from 'redux';
import reduxThunk from 'redux-thunk';
import logger from 'redux-logger';
import refreshTokenMiddleware from './refreshTokenMiddleware';
import reducer from '../reducers';

let Store;
if (process.env.NODE_ENV !== 'production') {
  Store = createStore(reducer, applyMiddleware(reduxThunk, logger));
} else {
  Store = createStore(reducer, applyMiddleware(reduxThunk));
}

export default Store;
